var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnquireFrom3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 44L23.5896 39.3274H17.0056V32.7434L12.333 28L17.0056 23.2566V16.6726H23.5896L28.333 12L33.0764 16.6726H39.6604V23.2566L44.333 28L39.6604 32.7434V39.3274H33.0764L28.333 44ZM24.1914 34.0177L28.333 31.5044L32.4746 34.0177L31.3773 29.3097L35.0587 26.1239L30.2091 25.7345L28.333 21.2743L26.4569 25.7345L21.6073 26.1239L25.2888 29.3097L24.1914 34.0177Z",
    fill: "#20566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquireFrom3);
export default __webpack_public_path__ + "static/media/enquireFrom3.4ed91fa89c6705824827ee1c9b90e160.svg";
export { ForwardRef as ReactComponent };